import { render, staticRenderFns } from "./FormularioAddNinos.vue?vue&type=template&id=7cb30097&scoped=true"
import script from "./FormularioAddNinos.vue?vue&type=script&lang=js"
export * from "./FormularioAddNinos.vue?vue&type=script&lang=js"
import style0 from "./FormularioAddNinos.vue?vue&type=style&index=0&id=7cb30097&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb30097",
  null
  
)

export default component.exports